import { baseApi } from '@/services'
import { Note, PaginatedResults } from '@/types/unlock'

export const notesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    listNotes: builder.query<PaginatedResults<Note[]>, string>({
      query: (application_id) => `v2/applications/${application_id}/notes/`,
      providesTags: () => ['ListOfNotes'],
    }),
    getNote: builder.query<Note, string>({
      query: (uuid) => `v2/notes/${uuid}/`,
    }),
    createNote: builder.mutation<Note, Partial<Note>>({
      query: (note) => ({
        method: 'POST',
        url: 'v2/notes/',
        body: note,
      }),
      invalidatesTags: ['ListOfNotes', 'StreamingNote'],
    }),
    updateNote: builder.mutation<Note, Partial<Note>>({
      query: (note) => ({
        method: 'PATCH',
        url: `v2/notes/${note.uuid}/`,
        body: note,
      }),
      invalidatesTags: ['ListOfNotes', 'StreamingNote'],
    }),
  }),
})

export const { useListNotesQuery, useGetNoteQuery, useCreateNoteMutation, useUpdateNoteMutation } =
  notesApi
